import { useQuery } from '@tanstack/react-query';
import type { VendorApplicationAdminDetail } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const vendorApplicationQueryKey = (applicationId: string) =>
  ['admin', 'vendor-application', applicationId] as const;

export const useVendorApplicationQuery = (applicationId: string | undefined) =>
  useQuery<VendorApplicationAdminDetail>({
    queryKey: vendorApplicationQueryKey(applicationId ?? ''),
    enabled: Boolean(applicationId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/admin/v1/vendor-applications/{applicationId}',
        {
          params: { path: { applicationId: applicationId as string } },
        },
      );
      return data as VendorApplicationAdminDetail;
    },
  });
